import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'

const QISoftware = () => {
    return (<>

        <Container className="outerContainer">
            <h2 className="mb-4 centerText" >Software Testing</h2>
            <Row>
                <Col className='stretchCard'>
                    <Card className="mb-4 centerText fullwidth">
                        <Card.Body>
                            <Card.Title>SAS v2021 and WinQI v2021 Comparison Testing</Card.Title>
                            <Card.Text>
                                July 2021
                            </Card.Text>
                            <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/V2021/SAS-WinQI_comparison_ICD-10v2021.pdf" variant="primary">Download</Button>
                        </Card.Body>

                    </Card>
                </Col>

                <Col className='stretchCard'>
                    <Card className="mb-4 centerText fullwidth">
                        <Card.Body>
                            <Card.Title>AHRQ QI Rate Comparison: SAS QI v2020 vs. SAS QI v2021</Card.Title>
                            <Card.Text>
                                July 2021
                            </Card.Text>
                            <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Software/V2021/AHRQ_QI_Rate_Comparison_v20120_v2021.pdf" variant="primary">Download</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <p className="centerText"><span className="bold danger">Note:</span> To learn frequently asked questions, <a href="https://www.qualityindicators.ahrq.gov/News/ICD10_v2021_FAQ.pdf">click here</a> to access v2021 software release FAQ document.</p>
        </Container>
    </>)
}

export default QISoftware;